<template>
  <div>
    <el-dialog
      title="编辑评论"
      :visible.sync="show"
      class="top-draft-dialog reply-comment-dialog"
      :before-close="handleClose"
      width="500px"
    >
      <div class="card">
        <div class="row table-responsive-main-list">
          <div class="col-md-12 pad-r-20">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label>用户</label>
                  <input
                    v-model="item.userName"
                    type="text"
                    class="form-control"
                    placeholder="用户名"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label>评论内容</label>
                  <textarea
                    placeholder="评论内容"
                    class="form-control"
                    v-model="item.message"
                  ></textarea>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label>附件</label>
                  <div class="annex-list">
                    <div
                      class="annex-item"
                      v-for="data in item.attachmentDtoList"
                      :key="data.id"
                    >
                      <div class="video-url-min">
                        <video
                          v-if="data.type != 'image'"
                          controls="controls"
                          :src="data.url"
                        ></video>
                        <img
                          v-if="data.type == 'image'"
                          :src="data.image"
                          alt=""
                        />
                      </div>
                      <span @click="removeAnnexs(data)">删除</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label>点赞数量</label>
                  <div>
                    <input
                      v-model="item.operateLikeNum"
                      type="text"
                      class="form-control mb-3"
                      placeholder="点赞数量"
                    />
                    <b-form-checkbox
                      v-model="item.hotState"
                      value="1"
                      unchecked-value="0"
                      class="mb-3"
                      checked
                      plain
                      >是否为热评</b-form-checkbox
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row submit-bar">
          <div class="col-md-12">
            <div class="bar-handle">
              <button
                @click="handleClose()"
                class="btn-sm btn btn-outline-dark"
                type="button"
              >
                取消
              </button>
              <button
                @click="submitCreate()"
                class="btn-sm btn btn-primary"
                type="button"
              >
                确定
              </button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import content from "@/server/api/comments";

export default {
  components: {},

  data() {
    return {
      loadingText: "加载中...",
      loadingAll: false,
      is_loading: false,
      item: {},
      show: false,
      modifyData: [], //有过修改的评论
      params: {
        page: 1,
        per_page: 20,
      },
      replys: [],
    };
  },

  props: {},

  mounted() {},

  methods: {
    showModel(item) {
      this.params = {
        page: 1,
        per_page: 20,
        id: item.id,
      };
      this.loadingText = "加载中...";
      this.loadingAll = false;
      this.is_loading = false;
      this.replys = [];
      this.item = {};
      this.modifyData = [];
      this.show = true;
      this.fetch(item);
      this.getReplys(item);
    },

    handleClose() {
      this.show = false;
    },

    getReplys(item) {
      content.replys(this.params).then((resp) => {
        if (resp.code == 0) {
          if (resp.data) {
            if (resp.data.totalPages > resp.data.page) {
              this.is_loading = false;
            } else {
              this.loadingText = "全部回复加载完毕～";
              this.is_loading = true;
              this.loadingAll = true;
            }
            if (resp.data.items) {
              resp.data.items.forEach(function(item) {
                item.initMessage = JSON.parse(JSON.stringify(item.message));
              });
              this.replys = this.replys.concat(resp.data.items);
              this.params.page = this.params.page + 1;
            }
          }
        }
      });
    },

    //获取评论数据
    fetch(item) {
      let params = {
        id: item.id,
      };
      content.detail(params).then((resp) => {
        if (resp.code == 0) {
          this.item = resp.data;
          this.item.operateLikeNum = resp.data.operateLikeNum;
        }
      });
    },

    submitCreate() {
      let current = {
        code: "comments",
      };
      let params = this.item;
      if (params.operateLikeNum) {
        params.operateLikeNum = Number(params.operateLikeNum);
      }
      params.replyComments = this.modifyData;
      content.modify(params).then((resp) => {
        if (resp.code == 0) {
          Vue.swal({
            icon: "success",
            title: "编辑成功！",
            showConfirmButton: false,
            timer: 1000,
          });
          this.handleClose();
          this.$emit("pageCallback", current);
        } else {
          Vue.swal(resp.msg);
        }
      });
    },

    deleteComment(data) {
      let params = {};
      params.ids = [];
      params.ids.push(data.id);
      content.remove(params).then((resp) => {
        if (resp.code == 0) {
          this.replys.splice(this.replys.indexOf(data), 1);
        }
      });
    },

    removeAnnexs(data) {
      this.item.attachmentDtoList.splice(
        this.item.attachmentDtoList.indexOf(data),
        1
      );
    },

    addModifyData(data) {
      for (var i = 0; i < this.modifyData.length; i++) {
        let item = this.modifyData[i];
        if (item.id == data.id) {
          this.modifyData.splice(i, 1);
        }
      }
      if (data.initMessage != data.message) {
        delete data.initMessage;
        this.modifyData.push(data);
      }
    },

    scrollEvent() {
      let _this = this;
      this.$nextTick(() => {
        const el = document.querySelector(".reply-comment-main");
        const offsetHeight = el.offsetHeight;
        console.log(offsetHeight);
        el.onscroll = () => {
          const scrollTop = el.scrollTop;
          const scrollHeight = el.scrollHeight;
          if (offsetHeight + scrollTop - scrollHeight >= -1) {
            if (!_this.loadingAll) {
              _this.is_loading = true;
              _this.getReplys();
            }
          }
        };
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-url-bg {
  border: 1px solid #ced4da;
  width: 300px;
  background-image: url(../../../../assets/images/default_cover_1_1.png);
  background-size: 100% 100%;
}

.reply-comment-main {
  overflow-y: auto;
  height: 100%;
}

.reply-item {
  margin-bottom: 20px;
}

.reply-item .user-info {
  width: 100%;
}

.reply-item .user-info img {
  width: 23px;
  height: 23px;
  float: left;
  border-radius: 50%;
  margin-right: 13px;
}

.reply-item .user-info .user-name {
  font-size: 14px;
  margin-bottom: 0;
  float: left;
}

.reply-item .user-info .user-name span {
  font-size: 12px;
  margin-left: 10px;
}

.reply-item .user-info .item-delete {
  float: right;
  font-size: 14px;
  cursor: pointer;
  line-height: 24px;
}

.reply-item .reply-content {
  width: 100%;
  padding-left: 36px;
}

.reply-item .reply-content p {
  /*font-size: 17px;*/
  margin-bottom: 0px;
}

.reply-item .reply-content span {
  margin-top: 5px;
  font-size: 12px;
  display: block;
  margin-bottom: 5px;
  padding-left: 5px;
}

.border-left-1 {
  border-left: 1px solid #ced4da;
}

.reply-comment-dialog .loading {
  line-height: 30px;
  text-align: center;
}
</style>
